import React from "react";
import WorkflowController from "./WorkflowManagementComponents/WorkflowController";

const WorkflowManagement = () => {
  return (
    <div className="mx-auto w-full max-w-screen-lg divide-y divide-gray-200 rounded-xl bg-white p-2">
      <WorkflowController />
    </div>
  );
};

export default WorkflowManagement;
